import React, { useState, useEffect } from "react";
import api from "@api";
import { Form } from "@components";
import { AccessAdminForProp } from "@api/types/accessadmin";
import { AccessAdminDetail } from "./detail";
import { M_TABLE_HEADERS_ACCESS_ADMINS } from "../constants";
import { Cell } from "@components/table/types";
import { Box, Button } from "@material-ui/core";
import { FilterType, Table } from "@components";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { exportAccessAdminMembers } from "@api/excel-exporters/exportAccessAdminMembers";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_ACCESS_ADMINS.GROUP_NAME },
  { data: M_TABLE_HEADERS_ACCESS_ADMINS.MEMBERS },
];

export const AccessAdmin: React.FC = () => {
  const form = Form.useManager<AccessAdminForProp>({
    id: 0,
    groupName: "",
    emailAddress: "",
  });

  const [openAccessAdmin, setOpenAccessAdmin] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedAccessAdmin, setSelectedAccessAdmin] = useState<
    AccessAdminForProp
  >();
  const [accessAdminList, setAccessAdminList] = useState([]);

  useEffect(() => {
    getDataList();
  }, []);

  useEffect(() => {
    if (openAccessAdmin) {
      if (selectedAccessAdmin) {
        form.set(Form.target.VALUE, ["id", selectedAccessAdmin.id]);
        form.set(Form.target.VALUE, [
          "groupName",
          selectedAccessAdmin.groupName,
        ]);
        form.set(Form.target.VALUE, [
          "emailAddress",
          selectedAccessAdmin.emailAddress,
        ]);
      }
    }
  }, [openAccessAdmin]);

  function getDataList() {
    api.accessadmin
      .getUserGroups()
      .then((response) => {
        let list: any = [];
        response.accessAdminUserGroups.forEach((d: any) => {
          list = [
            ...list,
            {
              id: d.id,
              groupName: d.groupName,
              emailAddress: "",
            },
          ];
        });
        // REMOVE THE APPROVERS IN THE LIST
        list = list.filter((x: any) => x.groupName !== "Approvers");
        setAccessAdminList(list);
      })
      .finally(() => setIsLoading(false))
      .catch((error) => {
        console.error(`Error in fetching salesforce role ${error}`);
      });
  }

  const isShowModal = openAccessAdmin ? (
    <AccessAdminDetail
      form={form}
      open={openAccessAdmin}
      onCancel={() => setOpenAccessAdmin(false)}
    />
  ) : (
    ""
  );

  const viewMembersIcon = (
    <span
      style={{
        display: "flex",
        justifyContent: "left",
        alignItems: "left",
      }}
    >
      <SupervisorAccountIcon />
    </span>
  );

  function handleExport() {
    exportAccessAdminMembers();
  }

  const pageName = "Access Admin";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      <Button style={{ float: "right" }} onClick={handleExport}>
        EXPORT TO EXCEL
      </Button>
      <Table
        data={accessAdminList.map((data: any) => ({
          cells: [
            {
              data: data.groupName,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedAccessAdmin(data);
                setOpenAccessAdmin(true);
              },
            },
            {
              data: viewMembersIcon,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedAccessAdmin(data);
                setOpenAccessAdmin(true);
              },
            },
          ],
          data,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_ACCESS_ADMINS.GROUP_NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_ACCESS_ADMIN_TOOLBAR"
        loading={isLoading}
      />
      {isShowModal}
    </Box>
  );
};
